<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-17 14:20:40
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-17 14:58:58
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/search/tag.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="goods-category">
		<div class="goods-lable fz-12">商品类目</div>
		<div :class="['goods-content', expandsFlag ? 'expand-all' : 'expand-fewer']">
			<div
				@click="pitchOn(item)"
				:class="['category-name', 'fz-12', 'pointer','mb-12', expandsFlag ? 'expand-all' : 'expand-fewer']"
				v-for="item in list"
				:key="item.category_id"
			>
				<span :class="[selectCategoryId.includes(item.category_id) ? 'active-category' : '']">{{ item.category_name }}</span>
			</div>
		</div>
		<div class="more fz-12 pointer" @click="expands">
			{{ expandsFlag ? '收起' : '展开' }}
			<i :class="['el-icon-arrow-down', 'icon-arrow', expandsFlag ? 'expand' : 'fewer']"></i>
		</div>
	</div>
</template>
<script>
import { commonCategory } from '@/api/shopManage';
import debounce from 'lodash/debounce';
export default {
	props:{
		platformId:{
			type: Number,
			default: +dataMap.PLATFORM_DY.value,
		}
	},
	data() {
		return {
			expandsFlag: false,
			checkList:[], 
			list:[],
		};
	},
	computed:{
		// 选中的商品类目
		selectCategoryId(){
			return this.checkList.length && this.checkList.map(val => val.category_id) || [-1];
		},
	},
	methods:{
		/**
		 * 商品类目列表
		 */
		async getList(){
			const { data } = await commonCategory({ platformId: this.platformId });
			this.list = [{ category_id: -1, category_name: '不限' },...data.list];
		},
		expands(){
			this.expandsFlag = !this.expandsFlag
		},
		/**
		 * 选中不限 清除所有选中的状态
		 *
		 */
		onClear(){
			this.checkMaps = new Map()
			this.checkList = [];
			this.$emit('change',this.checkList)
		},

		/**
		 * 选中所有的类目选项 则勾选不限状态
		 * @param {*} item
		 */
		onSelect(){
			let filterArr = this.selectCategoryId.filter((val => +val > -1));
			if((filterArr.length === this.list.length - 1)){
				this.onClear()
				return 
			}
			this.$emit('change',this.checkList)
		},

		pitchOn:debounce(function (item){
			let checkIndex = this.checkList.findIndex(val => val.category_id === item.category_id);
			if(checkIndex === -1){
				this.checkList.push(item)
			}else{
				this.checkList.splice(checkIndex,1)
			}
			/**如果选中不限 则之前选中的都取消 */
			if(item.category_id === - 1){
				this.onClear();
				return 
			}
			this.onSelect(item);
		},300)
	},
	created(){
		this.getList();
	}
};
</script>
<style lang="less" scoped>
.goods-category {
	display: flex;
	.goods-lable {
		margin-right: 32px;
		min-width: 48px;
		color: @color-gy7;
		font-family: 'PingFangSC-Regular';
	}
	.goods-content {
		display: flex;
		height: 22px;
		flex-wrap: wrap;
		overflow: hidden;
	}
	.category-name {
		margin-right: 28px;
		line-height: 20px;
		font-family: 'PingFangSC-Regular';
		color: @color-gy8;
	}
	.more {
		position: relative;
		min-width: 38px;
		line-height: 22px;
		display: flex;
		font-family: ' PingFangSC-Regular';
		color: @color-gy7;
	}
	.expand-all {
		height: 100%;
	}
	.expand-fewer {
		height: 20px;
		overflow: hidden;
	}
	.icon-arrow {
		left: 27px;
		position: absolute;
		top: 4px;
		transition: all .3s;
	}
	.expand {
		transform: rotate(180deg);
	}
	.active-category {
		color: @color-p;
	}
}
</style>
